import {omit} from '@coolcolduk/util';
import {TradeDb} from './tradeDbSchema';
import {tradeMessageDbSchema, type TradeMessageDb} from './tradeMessageDbSchema';
import {tradeWriteSchema} from './tradeWriteSchema';

/**
 * Map a partial trade write to partial DB fields (epoch ms timestamps).
 */
export function mapTradeWriteToDbUpdate(tradeWrite: Partial<TradeDb>): Partial<TradeDb> {
  const stripped = omit(tradeWrite, [
    'updatedAt',
    'createdAt',
    'sessionId',
    'tradeId',
    'symbol',
    'positionSize',
    'direction',
  ]);
  const now = Date.now();
  const parsed = tradeWriteSchema.partial().parse(stripped);
  const {messages: parsedMessages, ...rest} = parsed;
  const messages: TradeMessageDb[] | undefined =
    parsedMessages?.map((message) => tradeMessageDbSchema.parse(message)) ?? undefined;
  return {
    ...rest,
    updatedAt: now,
    ...(messages != null ? {messages} : {}),
  };
}
